import { createStore } from "redux";

import reducers from "./reducers";

import composedMiddleware from "data/middleware";

const setInitialState = (props) => {
  return {};
};

export default (props) => {
  const initialState = setInitialState(props);

  const store = createStore(reducers, initialState, composedMiddleware());

  return store;
};
